import { createAction } from 'typesafe-actions';

import { type OverlayConfig, openOverlay } from '../actions/Overlay';
import { MiniCoachmarkTypes } from '../constants/MiniCoachmark';
import { OVERLAY_ACTIONS, OVERLAY_CONFIG, OVERLAY_TYPES } from '../constants/Overlay';

interface CloseOverlayPayload {
  overlayConfig: OverlayConfig;
}

export const closeMiniCoachmark = createAction(
  OVERLAY_ACTIONS.CLOSE_OVERLAY,
  (miniCoachmarkType: $TSFixMe, uid: $TSFixMe) => ({
    overlayConfig: {
      [OVERLAY_CONFIG.SUBTYPE]: miniCoachmarkType,
      [OVERLAY_CONFIG.TYPE]: OVERLAY_TYPES.anchored,
      [OVERLAY_CONFIG.PROPS]: { uid },
    },
  }),
)<CloseOverlayPayload>();
export type CloseOverlayAction = ReturnType<typeof closeMiniCoachmark>;

export const buildMiniCoachmarkOverlayConfig = (
  miniCoachmarkType: $TSFixMe,
  uid: $TSFixMe,
): OverlayConfig => ({
  [OVERLAY_CONFIG.TYPE]: OVERLAY_TYPES.anchored,
  [OVERLAY_CONFIG.SUBTYPE]: miniCoachmarkType,
  [OVERLAY_CONFIG.PROPS]: {
    uid,
  },
});

export const openMiniCoachmark = (miniCoachmarkType: $TSFixMe, uid?: $TSFixMe) =>
  openOverlay(buildMiniCoachmarkOverlayConfig(miniCoachmarkType, uid));

export const openBingeSkipperCoachmark = () => openMiniCoachmark(MiniCoachmarkTypes.BINGE_SKIPPER);

interface HidePodcastCollectionsCoachmarkPayload {
  isUnmount: boolean;
}

export const hidePodcastCollectionsCoachmark = createAction(
  OVERLAY_ACTIONS.HIDE_PODCAST_COLLECTIONS_COACHMARK,
  (isUnmount: boolean) => ({ isUnmount }),
)<HidePodcastCollectionsCoachmarkPayload>();
export type HidePodcastCollectionsCoachmarkAction = ReturnType<
  typeof hidePodcastCollectionsCoachmark
>;

interface CoachmarkClickedPayload {
  coachmarkType: $TSFixMe;
  reason: $TSFixMe;
}

export const coachmarkClicked = createAction(
  OVERLAY_ACTIONS.COACHMARK_CLICKED,
  (coachmarkType: $TSFixMe, reason: $TSFixMe) => ({ coachmarkType, reason }),
)<CoachmarkClickedPayload>();
export type CoachmarkClickedAction = ReturnType<typeof coachmarkClicked>;
